import { connect } from "react-redux";

import { downloadHelpFile as onDownloadHelpFile } from "../../actions/downloadFilesActions";

const mapStateToProps = (state) => ({
  downloadHelpFileDataState: state.downloadFiles.downloadHelpFileDataState,
});

const mapDispatchToProps = { onDownloadHelpFile };

const withDownloadFiles = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withDownloadFiles };
